"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProfileSettings = exports.fetchViewPermissions = exports.deletePermissions = exports.fetchPermissionTableList = exports.editPermission = exports.createPermission = exports.fetchApplicationsList = exports.fetchActionsList = exports.getPermissionActions = exports.getPermissionById = exports.getPermissionsList = exports.getConsumerList = exports.fetchPolicyListSM = exports.deletePolicySM = exports.editPolicySM = exports.getSMPolicyList = exports.getPolicyList = exports.editPolicyByEntity = exports.deletePolicyId = exports.getPolicyByEntity = exports.createPolicy = exports.getRolesList = exports.editRoleById = exports.deleteRoleById = exports.getRoleById = exports.createRole = void 0;

var _utils = require("../components/profile-policy/utils");

var _apiService = _interopRequireDefault(require("../utils/api-service"));

var _commonConstants = require("../utils/common-constants");

var _commonUtils = require("../utils/common-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var headers = {
  'content-type': 'application/json'
}; // ROLES CRUD

var createRole = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var data, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            data = _ref.data;
            _context.next = 3;
            return _apiService.default.post('/api/v1/policy-admin/roles', JSON.parse(data), {
              headers: headers
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createRole(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.createRole = createRole;

var getRoleById = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref3) {
    var roleId, response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            roleId = _ref3.roleId;
            _context2.next = 3;
            return _apiService.default.get("/api/v1/policy-admin/roles/".concat(roleId));

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getRoleById(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

exports.getRoleById = getRoleById;

var deleteRoleById = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref5) {
    var roleId, response;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            roleId = _ref5.roleId;
            _context3.next = 3;
            return _apiService.default.delete("/api/v1/policy-admin/roles/".concat(roleId));

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function deleteRoleById(_x3) {
    return _ref6.apply(this, arguments);
  };
}(); // here roleId can be both Id as well as name


exports.deleteRoleById = deleteRoleById;

var editRoleById = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref7) {
    var roleId, data, response;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            roleId = _ref7.roleId, data = _ref7.data;
            _context4.next = 3;
            return _apiService.default.patch("/api/v1/policy-admin/roles/".concat(roleId), data);

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response.data);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function editRoleById(_x4) {
    return _ref8.apply(this, arguments);
  };
}();

exports.editRoleById = editRoleById;

var getRolesList = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
    var payload,
        params,
        response,
        _args5 = arguments;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
            params = {};

            if (payload !== null && payload !== void 0 && payload.next) {
              params.pageToken = (0, _commonUtils.getQueryParamsFromUrl)(payload.next, _commonConstants.PAGE_TOKEN);
            }

            _context5.next = 5;
            return _apiService.default.get('/api/v1/policy-admin/roles', {
              headers: headers,
              params: params
            });

          case 5:
            response = _context5.sent;
            return _context5.abrupt("return", response.data);

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function getRolesList() {
    return _ref9.apply(this, arguments);
  };
}(); //NOTE: Policy CRUD Services


exports.getRolesList = getRolesList;

var getPolicyRequestUrl = function getPolicyRequestUrl(consumer, consumerEntityId) {
  var baseEndpoint = '/api';
  var papServiceEndpoint = '/paps';

  if (consumer === _commonConstants.papServiceConsumer) {
    if ((0, _utils.isResourcePolicyPath)()) {
      return "".concat(baseEndpoint, "/resource-manager/policies");
    }

    if ((0, _utils.isServerAccessPath)()) {
      return "".concat(baseEndpoint, "/resource-manager/profiles/").concat(consumerEntityId, "/policies");
    }

    if ((0, _utils.isAccessBuilderPath)()) {
      return "".concat(baseEndpoint, "/profile-requests").concat(papServiceEndpoint, "/").concat(consumerEntityId, "/policies");
    }

    return "".concat(baseEndpoint).concat(papServiceEndpoint, "/").concat(consumerEntityId, "/policies");
  }

  return "".concat(baseEndpoint, "/v1/policy-admin/policies");
};

var createPolicy = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref10) {
    var data, resource, consumer, consumerEntityId, params, response;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            data = _ref10.data, resource = _ref10.resource, consumer = _ref10.consumer, consumerEntityId = _ref10.consumerEntityId;
            params = {};

            if (resource) {
              params.resource = resource;
            }

            if (consumer && consumer !== _commonConstants.papServiceConsumer) {
              params.consumer = consumer;
            }

            _context6.next = 6;
            return _apiService.default.post(getPolicyRequestUrl(consumer, consumerEntityId), data, {
              headers: headers,
              params: params
            });

          case 6:
            response = _context6.sent;
            return _context6.abrupt("return", response.data);

          case 8:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function createPolicy(_x5) {
    return _ref11.apply(this, arguments);
  };
}(); //policyEntity can be policyId or policyName


exports.createPolicy = createPolicy;

var getPolicyByEntity = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(policyEntity, resourcePath, consumer, consumerEntityId) {
    var params, response;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            params = {};
            params.conditionJson = true;

            if (resourcePath) {
              params.resource = resourcePath;
            }

            if (consumer && consumer !== _commonConstants.papServiceConsumer) {
              params.consumer = consumer;
            }

            _context7.next = 6;
            return _apiService.default.get("".concat(getPolicyRequestUrl(consumer, consumerEntityId), "/").concat(policyEntity), {
              params: params
            });

          case 6:
            response = _context7.sent;
            return _context7.abrupt("return", response.data);

          case 8:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function getPolicyByEntity(_x6, _x7, _x8, _x9) {
    return _ref12.apply(this, arguments);
  };
}();

exports.getPolicyByEntity = getPolicyByEntity;

var deletePolicyId = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
    var _ref14,
        _ref14$id,
        id,
        consumer,
        consumerEntityId,
        deleteRoleResp,
        _args8 = arguments;

    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _ref14 = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {}, _ref14$id = _ref14.id, id = _ref14$id === void 0 ? '' : _ref14$id, consumer = _ref14.consumer, consumerEntityId = _ref14.consumerEntityId;
            _context8.next = 3;
            return _apiService.default.delete("".concat(getPolicyRequestUrl(consumer, consumerEntityId), "/").concat(id));

          case 3:
            deleteRoleResp = _context8.sent;
            return _context8.abrupt("return", deleteRoleResp);

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function deletePolicyId() {
    return _ref13.apply(this, arguments);
  };
}(); //policyEntity can be policyId or policyName


exports.deletePolicyId = deletePolicyId;

var editPolicyByEntity = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(data, policyEntity, consumer, consumerEntityId) {
    var response;
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return _apiService.default.patch("".concat(getPolicyRequestUrl(consumer, consumerEntityId), "/").concat(policyEntity), data, {
              headers: headers
            });

          case 2:
            response = _context9.sent;
            return _context9.abrupt("return", response.data);

          case 4:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function editPolicyByEntity(_x10, _x11, _x12, _x13) {
    return _ref15.apply(this, arguments);
  };
}();

exports.editPolicyByEntity = editPolicyByEntity;

var getPolicyList = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
    var payload,
        params,
        policyListData,
        _args10 = arguments;
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            payload = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
            params = {};

            if (payload.search) {
              params.filter = "name%20co%20'".concat(payload.search, "'");
            }

            if (payload.next) {
              params.pageToken = (0, _commonUtils.getQueryParamsFromUrl)(payload.next, _commonConstants.PAGE_TOKEN);
            }

            _context10.next = 6;
            return _apiService.default.get('/api/v1/policy-admin/policies', {
              params: params
            });

          case 6:
            policyListData = _context10.sent;
            return _context10.abrupt("return", policyListData);

          case 8:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function getPolicyList() {
    return _ref16.apply(this, arguments);
  };
}();

exports.getPolicyList = getPolicyList;

var getSMPolicyList = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
    var payload,
        params,
        policyListData,
        _args11 = arguments;
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            payload = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {};
            params = {};
            params.resource = '*';

            if (payload.search) {
              params.filter = "name%20co%20'".concat(payload.search, "'");
            }

            params.consumer = _commonConstants.smConsumer;

            if (payload.next) {
              params.pageToken = (0, _commonUtils.getQueryParamsFromUrl)(payload.next, _commonConstants.PAGE_TOKEN);
            }

            _context11.next = 8;
            return _apiService.default.get('/api/v1/policy-admin/policies', {
              params: params
            });

          case 8:
            policyListData = _context11.sent;
            return _context11.abrupt("return", policyListData);

          case 10:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function getSMPolicyList() {
    return _ref17.apply(this, arguments);
  };
}();

exports.getSMPolicyList = getSMPolicyList;

var editPolicySM = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(data, resource, entity) {
    var id, params, response;
    return regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            id = data.id;
            params = {
              consumer: _commonConstants.smConsumer
            };

            if (resource) {
              params.resource = resource;
            }

            response = null;

            if (!entity) {
              _context12.next = 10;
              break;
            }

            _context12.next = 7;
            return _apiService.default.patch("/api/v1/policy-admin/policies/".concat(entity), data, {
              params: params
            });

          case 7:
            response = _context12.sent;
            _context12.next = 13;
            break;

          case 10:
            _context12.next = 12;
            return _apiService.default.patch("/api/v1/policy-admin/policies/".concat(id), data, {
              params: params
            });

          case 12:
            response = _context12.sent;

          case 13:
            return _context12.abrupt("return", response.data);

          case 14:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function editPolicySM(_x14, _x15, _x16) {
    return _ref18.apply(this, arguments);
  };
}();

exports.editPolicySM = editPolicySM;

var deletePolicySM = /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
    var payload,
        _payload$id,
        id,
        params,
        deleteRoleResp,
        _args13 = arguments;

    return regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            payload = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : {};
            _payload$id = payload.id, id = _payload$id === void 0 ? '' : _payload$id;
            params = {
              consumer: _commonConstants.smConsumer
            };

            if (payload.resource) {
              params.resource = payload.resource;
            }

            _context13.next = 6;
            return _apiService.default.delete("/api/v1/policy-admin/policies/".concat(id), {
              params: params
            });

          case 6:
            deleteRoleResp = _context13.sent;
            return _context13.abrupt("return", deleteRoleResp);

          case 8:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));

  return function deletePolicySM() {
    return _ref19.apply(this, arguments);
  };
}();

exports.deletePolicySM = deletePolicySM;

var fetchPolicyListSM = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
    var payload,
        params,
        policyListData,
        _args14 = arguments;
    return regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            payload = _args14.length > 0 && _args14[0] !== undefined ? _args14[0] : {};
            params = {};

            if (payload.search) {
              params.filter = "name%20co%20'".concat(payload.search, "'");
            }

            if (payload.resource) {
              params.resource = payload.resource;
            }

            params.consumer = _commonConstants.smConsumer;

            if (payload.next) {
              params.pageToken = (0, _commonUtils.getQueryParamsFromUrl)(payload.next, _commonConstants.PAGE_TOKEN);
            }

            _context14.next = 8;
            return _apiService.default.get('/api/v1/policy-admin/policies', {
              params: params
            });

          case 8:
            policyListData = _context14.sent;
            return _context14.abrupt("return", policyListData);

          case 10:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));

  return function fetchPolicyListSM() {
    return _ref20.apply(this, arguments);
  };
}();

exports.fetchPolicyListSM = fetchPolicyListSM;

var getConsumerList = /*#__PURE__*/function () {
  var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
    var consumerList;
    return regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return _apiService.default.get('/api/v1/policy-admin/consumers');

          case 2:
            consumerList = _context15.sent;
            return _context15.abrupt("return", consumerList.data);

          case 4:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));

  return function getConsumerList() {
    return _ref21.apply(this, arguments);
  };
}(); // Permission CRUD


exports.getConsumerList = getConsumerList;

var getPermissionsList = /*#__PURE__*/function () {
  var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
    var payload,
        params,
        response,
        _args16 = arguments;
    return regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            payload = _args16.length > 0 && _args16[0] !== undefined ? _args16[0] : {};
            params = {};

            if (payload !== null && payload !== void 0 && payload.next) {
              params.pageToken = (0, _commonUtils.getQueryParamsFromUrl)(payload.next, _commonConstants.PAGE_TOKEN);
            }

            _context16.next = 5;
            return _apiService.default.get('/api/v1/policy-admin/permissions', {
              headers: headers,
              params: params
            });

          case 5:
            response = _context16.sent;
            return _context16.abrupt("return", response.data);

          case 7:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));

  return function getPermissionsList() {
    return _ref22.apply(this, arguments);
  };
}();

exports.getPermissionsList = getPermissionsList;

var getPermissionById = /*#__PURE__*/function () {
  var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(id) {
    var response;
    return regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.next = 2;
            return _apiService.default.get("/api/v1/policy-admin/permissions/".concat(id), {
              headers: headers
            });

          case 2:
            response = _context17.sent;
            return _context17.abrupt("return", response.data);

          case 4:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));

  return function getPermissionById(_x17) {
    return _ref23.apply(this, arguments);
  };
}();

exports.getPermissionById = getPermissionById;

var getPermissionActions = /*#__PURE__*/function () {
  var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(consumer) {
    var response;
    return regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.next = 2;
            return _apiService.default.get("/api/v1/policy-admin/actions?filter=consumer%20eq%20".concat(consumer), {
              headers: headers
            });

          case 2:
            response = _context18.sent;
            return _context18.abrupt("return", response.data);

          case 4:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));

  return function getPermissionActions(_x18) {
    return _ref24.apply(this, arguments);
  };
}(); //NOTE: Permission CRUD Services

/***** Action List Api Call */


exports.getPermissionActions = getPermissionActions;

var fetchActionsList = /*#__PURE__*/function () {
  var _ref25 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(consumer) {
    var actionList;
    return regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.next = 2;
            return _apiService.default.get("/api/v1/policy-admin/actions?filter=consumer%20eq%20".concat(consumer));

          case 2:
            actionList = _context19.sent;
            return _context19.abrupt("return", actionList.data);

          case 4:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));

  return function fetchActionsList(_x19) {
    return _ref25.apply(this, arguments);
  };
}();
/***** Application List Api Call */


exports.fetchActionsList = fetchActionsList;

var fetchApplicationsList = /*#__PURE__*/function () {
  var _ref26 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
    var ApplicationsList;
    return regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.next = 2;
            return _apiService.default.get("/api/apps?view=extended");

          case 2:
            ApplicationsList = _context20.sent;
            return _context20.abrupt("return", ApplicationsList.data);

          case 4:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));

  return function fetchApplicationsList() {
    return _ref26.apply(this, arguments);
  };
}();
/***** Create Permission Api Call */


exports.fetchApplicationsList = fetchApplicationsList;

var createPermission = /*#__PURE__*/function () {
  var _ref27 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(payload) {
    var create;
    return regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            _context21.next = 2;
            return _apiService.default.post("/api/v1/policy-admin/permissions", payload, {
              headers: headers
            });

          case 2:
            create = _context21.sent;
            return _context21.abrupt("return", create.status);

          case 4:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));

  return function createPermission(_x20) {
    return _ref27.apply(this, arguments);
  };
}();
/***** Edit Permission Api Call */


exports.createPermission = createPermission;

var editPermission = /*#__PURE__*/function () {
  var _ref28 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(payload, id) {
    var response;
    return regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            _context22.next = 2;
            return _apiService.default.patch("/api/v1/policy-admin/permissions/".concat(id), payload, {
              headers: headers
            });

          case 2:
            response = _context22.sent;
            return _context22.abrupt("return", response.data);

          case 4:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));

  return function editPermission(_x21, _x22) {
    return _ref28.apply(this, arguments);
  };
}();
/***** Get Permissions List Api Call */


exports.editPermission = editPermission;

var fetchPermissionTableList = /*#__PURE__*/function () {
  var _ref29 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
    var payload,
        params,
        tableList,
        _args23 = arguments;
    return regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            payload = _args23.length > 0 && _args23[0] !== undefined ? _args23[0] : {};
            params = {};

            if (payload.search) {
              params.filter = "name%20co%20'".concat(payload.search, "'");
            }

            if (payload.next) {
              params.pageToken = (0, _commonUtils.getQueryParamsFromUrl)(payload.next, _commonConstants.PAGE_TOKEN);
            }

            _context23.next = 6;
            return _apiService.default.get('/api/v1/policy-admin/permissions', {
              params: params
            });

          case 6:
            tableList = _context23.sent;
            return _context23.abrupt("return", tableList.data);

          case 8:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));

  return function fetchPermissionTableList() {
    return _ref29.apply(this, arguments);
  };
}();
/***** Delete Permission Api Call */


exports.fetchPermissionTableList = fetchPermissionTableList;

var deletePermissions = /*#__PURE__*/function () {
  var _ref30 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(id) {
    var response;
    return regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            _context24.next = 2;
            return _apiService.default.delete("/api/v1/policy-admin/permissions/".concat(id));

          case 2:
            response = _context24.sent;
            return _context24.abrupt("return", response.status);

          case 4:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }));

  return function deletePermissions(_x23) {
    return _ref30.apply(this, arguments);
  };
}();
/***** Get Permission Details Api Call */


exports.deletePermissions = deletePermissions;

var fetchViewPermissions = /*#__PURE__*/function () {
  var _ref31 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25(id) {
    var viewPermissions;
    return regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            _context25.next = 2;
            return _apiService.default.get("/api/v1/policy-admin/permissions/".concat(id));

          case 2:
            viewPermissions = _context25.sent;
            return _context25.abrupt("return", viewPermissions.data);

          case 4:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25);
  }));

  return function fetchViewPermissions(_x24) {
    return _ref31.apply(this, arguments);
  };
}();

exports.fetchViewPermissions = fetchViewPermissions;

var getProfileSettings = /*#__PURE__*/function () {
  var _ref32 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26(consumerEntityId) {
    var path, response;
    return regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            path = (0, _utils.isServerAccessPath)() ? "/api/resource-manager/profile/".concat(consumerEntityId, "/advanced-settings") : "/api/paps/".concat(consumerEntityId, "/advanced-settings");
            _context26.next = 3;
            return _apiService.default.get(path);

          case 3:
            response = _context26.sent;
            return _context26.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 5:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26);
  }));

  return function getProfileSettings(_x25) {
    return _ref32.apply(this, arguments);
  };
}();

exports.getProfileSettings = getProfileSettings;